const utils = {
    tronWeb: false,
    contract: false,
    contractAddress: false,

    async setTronWeb(tronWeb, contractAddress) {
        this.tronWeb = tronWeb;
        this.contractAddress = contractAddress;
        this.contract = await tronWeb.contract().at(this.contractAddress)
    },

};

export default utils;